export enum Quantities {
  WORK_DEMAND = 'WORK_DEMAND',
  BASE_PLAN = 'BASE_PLAN',
  FORMATION = 'FORMATION',
  ROSTER = 'ROSTER'
}

export enum GroupBy {
  CATEGORY = 'category',
  FUNCTION = 'function'
}
